import type { ComboboxItemBase } from "@/components/ui/combobox";
import { useEffect, useState } from "react";
import type { WhoDrugFilterOptions } from "@/lib/api/generated/casedb";
import { toCatalogApiError } from "../../shared/utils/catalogErrors";
import { whoDrugFilterOptions } from "../services/whodrugApi";

export function useWhoDrugFilterOptions(open: boolean, releaseId: number) {
  const [options, setOptions] = useState<WhoDrugFilterOptions>({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    setOptions({}); setError("");
    if (!open || !releaseId) { setLoading(false); return; }
    const controller = new AbortController();
    setLoading(true);
    whoDrugFilterOptions(releaseId, controller.signal)
      .then(value => { if (!controller.signal.aborted) setOptions(value); })
      .catch(failure => { if (!controller.signal.aborted) setError(toCatalogApiError(failure).message); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [open, releaseId]);
  return { countries: options.countries ?? [], holders: options.holders ?? [], loading, error };
}

export function visibleWhoDrugFilterOptions(input: string, options: ComboboxItemBase[]): ComboboxItemBase[] {
  const query = input.trim().toLocaleLowerCase();
  return options.filter(option => option.label.toLocaleLowerCase().includes(query)).slice(0, 50);
}
